module.exports = __webpack_public_path__ + "img/ico_exclamation.13c4b54.png";